import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimulatorAppComponent } from './simulator-app.component';
import { PrebuildCircuitModule } from '../../../shared/components/prebuild-circuit/prebuild-circuit.module';
import { WsApplicationService } from 'src/app/shared/services/ws-application.service';

@NgModule({
  declarations: [
    SimulatorAppComponent
  ],
  imports: [
    CommonModule,
    PrebuildCircuitModule
  ],
  exports: [
    SimulatorAppComponent
  ],
  providers:[WsApplicationService]
})
export class SimulatorAppModule { }
